var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_61556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.766 8.3335H23.3327C24.2167 8.3335 25.0646 8.68469 25.6897 9.30981C26.3148 9.93493 26.666 10.7828 26.666 11.6668V17.2335L28.3327 18.9002L38.3327 11.6668V28.3335M26.666 26.6668V28.3335C26.666 29.2176 26.3148 30.0654 25.6897 30.6905C25.0646 31.3156 24.2167 31.6668 23.3327 31.6668H4.99935C4.11529 31.6668 3.26745 31.3156 2.64233 30.6905C2.01721 30.0654 1.66602 29.2176 1.66602 28.3335V11.6668C1.66602 10.7828 2.01721 9.93493 2.64233 9.30981C3.26745 8.68469 4.11529 8.3335 4.99935 8.3335H8.33268L26.666 26.6668Z",
    stroke: "currentColor",
    strokeWidth: 2.51083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 1.66675L38.3327 38.3334",
    stroke: "currentColor",
    strokeWidth: 2.51083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_61556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVideo);
export default __webpack_public_path__ + "static/media/no-video.2cc19f1d18af2e6bc149dc795738fde0.svg";
export { ForwardRef as ReactComponent };